module.exports = __webpack_public_path__ + "img/手.0f5fa47c.png";